import { useDispatch } from 'react-redux';
import { showContextMenu } from 'redux/mode/actions';
import * as S from './styles';
import { MenuItem } from 'menu/MenuItem';

export interface ProjectNameProps {
	label: string;
	menuItems?: MenuItem[];
}

const ProjectName = ({ label, menuItems }: ProjectNameProps) => {
	const dispatch = useDispatch();

	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------	const onContextMenu = async (e: React.MouseEvent, frame: Frame) => {
	const onContextMenu = async (e: React.MouseEvent) => {
		if (!menuItems) return;
		if (e.target instanceof HTMLElement) {
			dispatch(
				showContextMenu({
					point: { x: e.clientX + 5, y: e.clientY },
					menuItems,
				})
			);
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base onContextMenu={(e) => onContextMenu(e)}>
			<S.Label>{label}</S.Label>
		</S.Base>
	);
};

export default ProjectName;
